import { Box, Button, useTheme } from '@mui/material'
import dayjs from 'dayjs'
import { FC, useState } from 'react'
import weekday from 'dayjs/plugin/weekday'
import { getWeekdayNames } from 'src/components/routes/_common/helpers'

dayjs.extend(weekday)

type LoadedDaySelectorProps = {
  initialSelectedDays?: string[]
  onChange?: (newValue: string[]) => void
  disabled?: boolean
}

const LoadedDaySelector: FC<LoadedDaySelectorProps> = ({
  initialSelectedDays,
  onChange,
  disabled,
}) => {
  const theme = useTheme()

  const [selectedDays, setSelectedDays] = useState<string[]>(
    initialSelectedDays ?? []
  )

  const handleToggleDay = (day: string) => {
    setSelectedDays((prevSelectedDays) => {
      if (prevSelectedDays.includes(day)) {
        const newSelectedDays = prevSelectedDays.filter((d) => d !== day)
        onChange && onChange(newSelectedDays)
        return newSelectedDays
      } else {
        const newSelectedDays = [...prevSelectedDays, day]
        onChange && onChange(newSelectedDays)
        return [...prevSelectedDays, day]
      }
    })
  }

  return (
    <Box>
      {getWeekdayNames().map((weekday) => (
        <Button
          key={weekday}
          disabled={disabled}
          onClick={() => handleToggleDay(weekday)}
          sx={{
            width: 35,
            height: 35,
            borderRadius: '50%',
            minWidth: 0,
            marginRight: 1,
            boxShadow: 'unset',
            backgroundColor: () => {
              if (disabled) {
                return theme.palette.grey[400]
              }

              return selectedDays.includes(weekday)
                ? theme.palette.primary.main
                : theme.palette.grey[400]
            },
            color: 'white',
            '&:hover': {
              backgroundColor: selectedDays.includes(weekday)
                ? theme.palette.primary.main
                : theme.palette.grey[600],
            },
          }}
        >
          {weekday[0]}
        </Button>
      ))}
    </Box>
  )
}

export default LoadedDaySelector
